import { handleActions } from 'redux-actions';
import updateEmail from '../../actions/updateEmail';
/**
 * Reducer intended for use to store a user's email as they are typing it out in a text input.
 *
 * Can be updated by the `updateEmail` action in the `subscription` model
 *
 * ```js
 * import { subscription } from '@minerva-analytics/pantheon';
 *
 * const { email } = subscription.reducers;
 *
 * // Note that this is not how you should actually use `email`, this is just to
 * // demonstrate what it can return when called by redux
 * email(); // ''
 * email('', subscription.actions.updateEmail('test@test.com')); // 'test@test.com'
 *
 * // To select data from this reducer in a component
 * import { useSelector } from 'react-redux';
 *
 * const Test = () => {
 *   // Note that you may need to change this depending on where the subscriber
 *   // model is integrated in your store
 *   const email = useSelector((state) => state.subscriber.email);
 *
 *   return <div>Test</div>
 * };
 */

var email = handleActions(new Map([[updateEmail, function (_, action) {
  return action.payload;
}]]), '');
export default email;